"use client"

import dynamic from "next/dynamic"
import { SAMPLE_STAR_MAP } from "./sample-data"

const CinematicStarfield = dynamic(
  () => import("./cinematic-starfield").then(m => ({ default: m.CinematicStarfield })),
  { ssr: false, loading: () => <div className="h-[min(80vh,700px)]" /> }
)

export function StarMapSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundColor: "var(--brand-pitch-black)" }}
    >
      <p
        className="relative z-10 pt-20 pb-4 text-center font-[var(--font-instrument-serif)] text-xl italic"
        style={{ color: "var(--brand-moon)" }}
      >
        Every mind has a signature.
      </p>
      <p
        className="relative z-10 pb-8 text-center font-[var(--font-instrument-serif)] text-xl italic"
        style={{ color: "var(--brand-moon)", opacity: 0.7 }}
      >
        Find out where yours lives amongst the stars.
      </p>

      <CinematicStarfield starMap={SAMPLE_STAR_MAP} />

      <p
        className="relative z-10 pt-8 pb-20 text-center text-base"
        style={{ color: "var(--brand-moon)", opacity: 0.7 }}
      >
        16 constellations. 128 figures. Yours will be different.
      </p>
    </section>
  )
}
